import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { 
  features,
  language
} from '../config';
import Firebase from '../api/Firebase';

export default function CancellationReasons() {
  // const { api } = useContext(FirebaseContext);
  const { api } = Firebase;

  const {
    addCancellationReason,
    editCancellationReason,
    deleteCancellationReason
  } = api;
  const columns = [
    { title: language.reason, field: 'label' ,render: rowData => <span>{rowData.label}</span>}
  ];
  
  const [data, setData] = useState([]);
  const cancelreasondata = useSelector(state => state.cancelreasondata);
  const dispatch = useDispatch();

  useEffect(() => {
    if (cancelreasondata.complex) {
      setData(cancelreasondata.complex);
    }else{
      setData([]);
    }
  }, [cancelreasondata.complex]);

  return (
    cancelreasondata.loading ? <CircularLoading /> :
      <MaterialTable
        title={language.cancellation_reasons}
        columns={columns}
        data={data}
        options={{
          exportButton: true,
          pageSize: 10
        }}
        editable={features.AllowCriticalEditsAdmin ? {
            onRowAdd: newData =>
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                console.log("newData", newData)
                // const tblData = [...data];
                // const value = tblData.length > 0 ? tblData[tblData?.length - 1]?.value : 0
                // newData.value = value
                // tblData.push(newData);
                dispatch(addCancellationReason(newData.label, "Add"));
              }, 600);
            }),
          onRowUpdate: (newData, oldData) =>
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                // console.log("kduf", newData, oldData)
                // const tblData = data;
                // tblData[tblData.indexOf(oldData)] = newData;
                dispatch(editCancellationReason(newData, "Update"));
              }, 600);
            }),
          onRowDelete: oldData =>
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                dispatch(deleteCancellationReason(oldData._id, "Delete"));
              }, 600);
            }),
        } : null}
      />
  );
}
